import Restaurant from "../restaurant-card/restaurant";
import Filters from "../filters/filters";
import { useEffect, useState } from "react";
import "./restaurants.scss";
import { useNavigate } from "react-router-dom";
import ScrollToTopButton from "../../commonComponents/go-up-button/scrollToTopButton";
import jwt_decode from "jwt-decode";
import { useSelector } from "react-redux";
import NavBar from "../../commonComponents/navBar/navbar";
import { FcEmptyFilter } from "react-icons/fc";
function Restaurants() {
  const navigate = useNavigate();
  const [restaurants, setRestaurants] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [locationSeleced, setLocationSeleced] = useState(
    JSON.parse(localStorage.getItem("location"))
  );
  const [inputAddressLabel, setInputAddressLabel] = useState({});
  const [restaurantsChanged, setRestaurantsChanged] = useState(true);
  const [toggleRating, setToggleRating] = useState(false);
  const [toggleDeliveryTime, setToggleDeliveryTime] = useState(false);
  const [toggleFavorite, setToggleFavorite] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const handleRestaurantClick = (data, index) => {
    sessionStorage.setItem("restaurantClicked", JSON.stringify(data));

    navigate("/restaurant/restaurantView");
  };

  const fetchRestaurants = async () => {
    const token = localStorage.getItem("token");
    let userX;
    let userY;
    let context;
    if (token) {
      const decodedToken = jwt_decode(token);
      console.log(decodedToken.address.x);
      console.log(decodedToken.address.y);
      console.log(decodedToken.address.context);

      const locationFromLocalStorage = JSON.parse(
        localStorage.getItem("location")
      );
      console.log(locationFromLocalStorage.label);
      console.log(decodedToken.address.label);
      if (decodedToken.address.label !== locationFromLocalStorage.label) {
        context = locationFromLocalStorage.context;
        userX = locationFromLocalStorage.x;
        userY = locationFromLocalStorage.y;
      } else {
        context = decodedToken.address.context;
        userX = decodedToken.address.x;
        userY = decodedToken.address.y;
      }
    } else {
      if (Object.keys(inputAddressLabel).length !== 0) {
        console.log(inputAddressLabel);
        context = inputAddressLabel.context;
        userX = inputAddressLabel.x;
        userY = inputAddressLabel.y;
        console.log(userX);
        console.log(userY);
      } else if (locationSeleced) {
        console.log(locationSeleced);
        context = locationSeleced.context;
        userX = locationSeleced.x;
        userY = locationSeleced.y;
        console.log(userX);
        console.log(userY);
      }
    }
    try {
      const response = await fetch(
        "https://femez.onrender.com/API/restaurant/restaurants",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ userX, userY, context, token }),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch restaurants");
      }
      const data = await response.json();
      // sessionStorage.setItem("restaurants", JSON.stringify(data));
      // dispatch({ type: "SET_RESTAURANTS", payload: data });
      console.log(data);

      setRestaurants(data.nearbyRestaurants);
      setFavorites(data.favoriteRestaurants);
      setRestaurantsChanged(!restaurantsChanged);
      if (data.nearbyRestaurants) {
        sessionStorage.setItem(
          "restaurants",
          JSON.stringify(
            data.nearbyRestaurants
              ? data.nearbyRestaurants.map((item) => item)
              : []
          ) || []
        );
      }
      if (data.favoriteRestaurants) {
        sessionStorage.setItem(
          "favorites",
          JSON.stringify(
            data.favoriteRestaurants
              ? data.favoriteRestaurants.map((item) => item._id)
              : []
          ) || []
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRestaurants();
    console.log(inputAddressLabel);
  }, [inputAddressLabel]);
  // useEffect(() => {}, [toggleRating]);
  return (
    <div className="global-container">
      <NavBar setInputAddressLabel={setInputAddressLabel} />
      <ScrollToTopButton />
      <div className="container-restaurant">
        <div className="filterBar">
          <div className="sort-by-div">
            <FcEmptyFilter className="filter-icon" />
            <h1>Filters</h1>
          </div>
          <div className="filterBar-elements">
            <Filters
              restaurants={restaurants}
              favorites={favorites}
              setRestaurants={setRestaurants}
              toggleRating={toggleRating}
              setToggleRating={setToggleRating}
              toggleDeliveryTime={toggleDeliveryTime}
              setToggleDeliveryTime={setToggleDeliveryTime}
              toggleFavorite={toggleFavorite}
              setToggleFavorite={setToggleFavorite}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            />
          </div>
        </div>

        <div className="restaurants-container">
          {/* <h1>Restaurants Suggested For You</h1> */}
          <div>
            {loading ? (
              <p>Loading...</p>
            ) : (
              <div className="restaurants">
                {restaurants.length > 0 ? (
                  restaurants.map((item, index) => (
                    <Restaurant
                      key={index}
                      image={`https://femez.onrender.com/${item.cover}`}
                      name={item.restaurant_name}
                      location={item.address.label}
                      review={item.restaurant_review}
                      onClick={() => handleRestaurantClick(item, index)}
                      restaurant_id={item._id}
                      timeDeliveryEstimate={Math.floor(item.distance * 10)}
                      category={item.restaurant_category}
                    />
                  ))
                ) : (
                  <p>No restaurants in your area</p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Restaurants;
